mobileSize = 1070;
function buttonfeature(){
  const e = $(".featureLineupContainer");
  e.length > 0 &&
      e.each((e, t) => {
          const i = $(t).find(".featureLineup-more"),
              n = $(t).find(".featureLineup-text"),
              a = n.text();
          n.html(`<span class="featureLineup-text-content">${a}</span>`), i.appendTo(n);
      });

}
$(document).ready(function(){

  // General Message
  $('.generalmessage').prependTo('header');
  // Check Window Size
  const windowSize = $(window).width();

  if (windowSize < 1070) {
    $('body')
      .addClass('saffireMobileSize')
      .removeClass('saffireLargeSize');
  } if (windowSize > 1071) {
    $('body').removeClass('saffireMobileSize');
  }
  buttonfeature();
});

$(window).load(function(){
	$('body').addClass('pageIsLoaded');
});